import React from 'react'

import { reactClass } from '../../../utils'
import * as Styled from './styles'

export type FormControlProps = {
  children?: React.ReactNode
  className?: string
  flex?: number | string
  height?: number | string
  margin?: number | string
  maxHeight?: number | string
  maxWidth?: number | string
  minHeight?: number | string
  minWidth?: number | string
  padding?: number | string
  width?: number | string
}

export const FormControl = React.forwardRef<HTMLDivElement, FormControlProps>(
  ({ children, ...rest }: FormControlProps, ref) => {
    return (
      <Styled.FormControlWrapper className={reactClass('form-control')} ref={ref} {...rest}>
        {children}
      </Styled.FormControlWrapper>
    )
  },
)
